<div class="all-title-box">
    <div class="container text-center">
        <h1>Pricing<span class="m_1">Lorem Ipsum dolroin gravida nibh vel velit.</span></h1>
    </div>
</div>

<div id="pricing-box" class="section wb">
    <div class="container">
        <div class="row">
            <div class="col-md-4 col-sm-6">
                <div class="pricingTable">
                    <div class="pricingTable-header">
                        <span class="heading">
                            <h3>Standard</h3>
                        </span>
                        <span class="price-value">$15<span class="month">month</span> <span>Lorem ipsum </span><span>Lorem ipsum dolor sit amet</span></span>
                    </div>

                    <div class="pricingContent">
                        <i class="fa fa-adjust"></i>
                        <ul>
                            <li>50GB Disk Space</li>
                            <li>50 Email Accounts</li>
                            <li>50GB Monthly Bandwidth</li>
                            <li>10 subdomains</li>
                            <li>50 Domains</li>
                        </ul>
                    </div><!-- /  CONTENT BOX-->

                    <div class="pricingTable-sign-up">
                        <a href="#" class="hover-btn-new"><span>sign up</span></a>
                    </div><!-- BUTTON BOX-->
                </div>
            </div>

            <div class="col-md-4 col-sm-6">
                <div class="pricingTable pink">
                    <div class="pricingTable-header">
                        <span class="heading">
                            <h3>Business</h3>
                        </span>
                        <span class="price-value">$30<span class="month">month</span> <span>Lorem ipsum</span><span>Lorem ipsum dolor sit amet</span></span>
                    </div>

                    <div class="pricingContent">
                        <i class="fa fa-briefcase"></i>
                        <ul>
                            <li>70GB Disk Space</li>
                            <li>70 Email Accounts</li>
                            <li>70GB Monthly Bandwidth</li>
                            <li>30 subdomains</li>
                            <li>70 Domains</li>
                        </ul>
                    </div><!-- /  CONTENT BOX-->

                    <div class="pricingTable-sign-up">
                        <a href="#" class="hover-btn-new"><span>sign up</span></a>
                    </div><!-- BUTTON BOX-->
                </div>
            </div>

            <div class="col-md-4 col-sm-6">
                <div class="pricingTable orange">
                    <div class="pricingTable-header">
                        <span class="heading">
                            <h3>Premium</h3>
                        </span>
                        <span class="price-value">$45<span class="month">month</span> <span>Lorem ipsum</span><span>Lorem ipsum dolor sit amet</span></span>
                    </div>

                    <div class="pricingContent">
                        <i class="fa fa-cube"></i>
                        <ul>
                            <li>80GB Disk Space</li>
                            <li>80 Email Accounts</li>
                            <li>80GB Monthly Bandwidth</li>
                            <li>40 subdomains</li>
                            <li>80 Domains</li>
                        </ul>
                    </div><!-- /  CONTENT BOX-->

                    <div class="pricingTable-sign-up">
                        <a href="#" class="hover-btn-new"><span>sign up</span></a>
                    </div><!-- BUTTON BOX-->
                </div>
            </div>
        </div>
    </div>
</div><!-- end section -->


<div class="section lb">
    <div class="container">
        <div class="section-title text-center">
            <h3>Ready to get started?</h3>
            <div class="dmoain-pricing">
                <div class="table-responsive-sm">
                    <table>
                        <thead>
                            <tr class="domain-head">
                                <th scope="col">
                                    Domain Name
                                </th>
                                <th scope="col">
                                    Registration Pricing
                                </th>
                                <th scope="col">
                                    Renewal Pricing
                                </th>
                                <th scope="col">
                                    Transfer Pricing
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td data-label="DOMAIN NAME">.com</td>
                                <td data-label="registration pricing">15.00 / yr</td>
                                <td data-label="renewal pricing">$30 / yr</td>
                                <td data-label="transfer-price">$45.00</td>
                            </tr>
                            <tr>
                                <td data-label="DOMAIN NAME">.net</td>
                                <td data-label="registration pricing">15.00 / yr</td>
                                <td data-label="renewal pricing">$20 / yr</td>
                                <td data-label="transfer-price">$45.00</td>
                            </tr>
                            <tr>
                                <td data-label="DOMAIN NAME">.org</td>
                                <td data-label="registration pricing">15.00 / yr</td>
                                <td data-label="renewal pricing">$19 / yr</td>
                                <td data-label="transfer-price">$45.00</td>
                            </tr>
                            <tr>
                                <td data-label="DOMAIN NAME">.in</td>
                                <td data-label="registration pricing">15.00 / yr</td>
                                <td data-label="renewal pricing">$18 / yr</td>
                                <td data-label="transfer-price">$45.00</td>
                            </tr>
                            <tr>
                                <td data-label="DOMAIN NAME">.biz</td>
                                <td data-label="registration pricing">15.00 / yr</td>
                                <td data-label="renewal pricing">$17 / yr</td>
                                <td data-label="transfer-price">$45.00</td>
                            </tr>
                            <tr>
                                <td data-label="Acount">.info</td>
                                <td data-label="registration pricing">15.00 / yr</td>
                                <td data-label="renewal pricing">$16 / yr</td>
                                <td data-label="transfer-price">$45.00</td>
                            </tr>
                            <tr>
                                <td data-label="DOMAIN NAME">.co.uk</td>
                                <td data-label="registration pricing">15.00 / yr</td>
                                <td data-label="renewal pricing">$15 / yr</td>
                                <td data-label="transfer-price">$45.00</td>
                            </tr>
                            <tr>
                                <td data-label="DOMAIN NAME">.name</td>
                                <td data-label="registration pricing">15.00 / yr</td>
                                <td data-label="renewal pricing">$14 / yr</td>
                                <td data-label="transfer-price">$45.00</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div><!-- end title -->
    </div><!-- end container -->
</div><!-- end section -->

<div id="testimonials" class="parallax section db parallax-off" style="background-image:url('assets/images/parallax_04.jpg');">
    <div class="container">
        <div class="section-title text-center">
            <h3>Testimonials</h3>
            <p>Lorem ipsum dolor sit aet, consectetur adipisicing lit sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </p>
        </div><!-- end title -->

        <div class="row">
            <div class="col-md-12 col-sm-12">
                <div class="testi-carousel owl-carousel owl-theme">
                    <div class="testimonial clearfix">
                        <div class="desc">
                            <h3><i class="fa fa-quote-left"></i> Wonderful Support!</h3>
                            <p class="lead">They have got my project on time with the competition with a sed highly skilled, and experienced & professional team.</p>
                        </div>
                        <div class="testi-meta">
                            <img src="assets/images/testi_01.png" alt="" class="img-fluid">
                            <h4>James Fernando </h4>
                        </div>
                        <!-- end testi-meta -->
                    </div>
                    <!-- end testimonial -->

                    <div class="testimonial clearfix">
                        <div class="desc">
                            <h3><i class="fa fa-quote-left"></i> Awesome Services!</h3>
                            <p class="lead">Explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you completed.</p>
                        </div>
                        <div class="testi-meta">
                            <img src="assets/images/testi_02.png" alt="" class="img-fluid">
                            <h4>Jacques Philips </h4>
                        </div>
                        <!-- end testi-meta -->
                    </div>
                    <!-- end testimonial -->

                    <div class="testimonial clearfix">
                        <div class="desc">
                            <h3><i class="fa fa-quote-left"></i> Great & Talented Team!</h3>
                            <p class="lead">The master-builder of human happines no one rejects, dislikes avoids pleasure itself, because it is very pursue pleasure. </p>
                        </div>
                        <div class="testi-meta">
                            <img src="assets/images/testi_03.png" alt="" class="img-fluid ">
                            <h4>Venanda Mercy </h4>
                        </div>
                        <!-- end testi-meta -->
                    </div>
                    <!-- end testimonial -->
                    <div class="testimonial clearfix">
                        <div class="desc">
                            <h3><i class="fa fa-quote-left"></i> Wonderful Support!</h3>
                            <p class="lead">They have got my project on time with the competition with a sed highly skilled, and experienced & professional team.</p>
                        </div>
                        <div class="testi-meta">
                            <img src="assets/images/testi_01.png" alt="" class="img-fluid">
                            <h4>James Fernando </h4>
                        </div>
                        <!-- end testi-meta -->
                    </div>
                    <!-- end testimonial -->

                    <div class="testimonial clearfix">
                        <div class="desc">
                            <h3><i class="fa fa-quote-left"></i> Awesome Services!</h3>
                            <p class="lead">Explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you completed.</p>
                        </div>
                        <div class="testi-meta">
                            <img src="assets/images/testi_02.png" alt="" class="img-fluid">
                            <h4>Jacques Philips </h4>
                        </div>
                        <!-- end testi-meta -->
                    </div>
                    <!-- end testimonial -->

                    <div class="testimonial clearfix">
                        <div class="desc">
                            <h3><i class="fa fa-quote-left"></i> Great & Talented Team!</h3>
                            <p class="lead">The master-builder of human happines no one rejects, dislikes avoids pleasure itself, because it is very pursue pleasure. </p>
                        </div>
                        <div class="testi-meta">
                            <img src="assets/images/testi_03.png" alt="" class="img-fluid">
                            <h4>Venanda Mercy </h4>
                        </div>
                        <!-- end testi-meta -->
                    </div><!-- end testimonial -->
                </div><!-- end carousel -->
            </div><!-- end col -->
        </div><!-- end row -->
    </div><!-- end container -->
</div><!-- end section -->

<div class="parallax section dbcolor">
    <div class="container">
        <div class="row logos">
            <div class="col-md-2 col-sm-2 col-xs-6 wow fadeInUp">
                <a href="#"><img src="assets/images/logo_01.png" alt="" class="img-repsonsive"></a>
            </div>
            <div class="col-md-2 col-sm-2 col-xs-6 wow fadeInUp">
                <a href="#"><img src="assets/images/logo_02.png" alt="" class="img-repsonsive"></a>
            </div>
            <div class="col-md-2 col-sm-2 col-xs-6 wow fadeInUp">
                <a href="#"><img src="assets/images/logo_03.png" alt="" class="img-repsonsive"></a>
            </div>
            <div class="col-md-2 col-sm-2 col-xs-6 wow fadeInUp">
                <a href="#"><img src="assets/images/logo_04.png" alt="" class="img-repsonsive"></a>
            </div>
            <div class="col-md-2 col-sm-2 col-xs-6 wow fadeInUp">
                <a href="#"><img src="assets/images/logo_05.png" alt="" class="img-repsonsive"></a>
            </div>
            <div class="col-md-2 col-sm-2 col-xs-6 wow fadeInUp">
                <a href="#"><img src="assets/images/logo_06.png" alt="" class="img-repsonsive"></a>
            </div>
        </div><!-- end row -->
    </div><!-- end container -->
</div><!-- end section -->